import { Navigate, Route, Routes } from "react-router-dom";

import {
  UsersPage,
  ClientesPage,
  DomiciliariosPage,
  LoginPage,
  AddressesUsersPage,
  ProductCharacteristicsPages,
  ProductCategoriesPage,
  ProductCategoriesByIdPage,
  RatingsPage,
  BannersPage,
  ProductsPage,
  ProductsByIdPage,
  PopularProductsPage,
  OrdersPage,
  OrdersByIdPage,
  TaxPage,
  BrandsPage,
  DiscountCodePage,
  ContactsDirectoryPage,
  DirectoryCategoriesPage,
  DirectoryCategoriesByIdPage,
  WalletBonusPages,
  WalletMovementsPage,
  WalletBalancePage,
  CoursesCategoriesPage,
  CoursesPage,
  CoursesByIdPage,
  CMSPage,
  CMSByIdPage,
  WorkOffersPage,
  WorkOffersByIdPage,
  ListCustomerGroupsPage,
  ListCustomerGroupsByIdPage,
  BannersProductsPage,
  SystemVariablesPage,
  ConfigurationCashbackPage,
  StoresPage,
  SauceIdPage,
  SaucesPage,
  AccompanimentsPage,
  AccompanimentByIdPage,
  Rules2x1Page,
  Product2x1Page,
  Rules3x2Page,
  Product3x2Page,
  RulesFiftyOffPage,
  RulesSushiLunchPage,
  SushiLunchProductsPage,
  MessagesPage,
  PromotionsPage,
  ShippingRatesPage,
} from "../pages";
import { LegacyPromotionsRedirectPage } from "../pages/LegacyPromotionsRedirectPage";
import { CitiesPage } from "../pages/CitiesPage";
import { StatesPage } from "../pages/StatesPage";
import { useAppRouter } from "./hooks";
import { WorkOffersCategoriesPage } from "../pages/WorkOffersCategoriesPage";

export const AppRouter = () => {
  const { auth } = useAppRouter();
  return (
    <Routes>
      <Route
        path="/"
        element={
          auth === true ? (
            <Navigate to="/orders" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {auth && (
        <>
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/orders/:id" element={<OrdersByIdPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/clientes" element={<ClientesPage />} />
          <Route path="/domiciliarios" element={<DomiciliariosPage />} />
          <Route path="/addressesUsers" element={<AddressesUsersPage />} />
          <Route
            path="/productCharacteristics"
            element={<ProductCharacteristicsPages />}
          />
          <Route
            path="/productCategories"
            element={<ProductCategoriesPage />}
          />
          <Route
            path="/productCategories/:id"
            element={<ProductCategoriesByIdPage />}
          />
          <Route path="/ratings" element={<RatingsPage />} />
          <Route path="/banners" element={<BannersPage />} />
          <Route
            path="/bannersProducts/:id"
            element={<BannersProductsPage />}
          />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:id" element={<ProductsByIdPage />} />
          <Route path="/popular-products" element={<PopularProductsPage />} />
          <Route path="/tax" element={<TaxPage />} />
          <Route path="/cities" element={<CitiesPage />} />
          <Route path="/systemVariables" element={<SystemVariablesPage />} />
          <Route
            path="/configuration-cashback"
            element={<ConfigurationCashbackPage />}
          />
          <Route path="/states" element={<StatesPage />} />
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="/discountCode" element={<DiscountCodePage />} />
          <Route
            path="/listCustomerGroups"
            element={<ListCustomerGroupsPage />}
          />
          <Route
            path="/listCustomerGroups/:id"
            element={<ListCustomerGroupsByIdPage />}
          />

          <Route
            path="/directoryCategories"
            element={<DirectoryCategoriesPage />}
          />
          <Route
            path="/directoryCategories/:id"
            element={<DirectoryCategoriesByIdPage />}
          />
          <Route
            path="/contactsDirectory"
            element={<ContactsDirectoryPage />}
          />
          <Route path="/walletBonus" element={<WalletBonusPages />} />
          <Route path="/walletMovements" element={<WalletMovementsPage />} />
          <Route path="/walletBalance" element={<WalletBalancePage />} />
          <Route
            path="/coursesCategories"
            element={<CoursesCategoriesPage />}
          />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/courses/:id" element={<CoursesByIdPage />} />
          <Route path="/cms" element={<CMSPage />} />
          <Route path="/cms/:id" element={<CMSByIdPage />} />
          <Route
            path="/workOffersCategories"
            element={<WorkOffersCategoriesPage />}
          />
          <Route path="/workOffers" element={<WorkOffersPage />} />
          <Route path="/workOffers/:id" element={<WorkOffersByIdPage />} />
          <Route
            path="/fulfillmentCompany"
            element={<Navigate to="/shipping-rates" replace />}
          />
          <Route
            path="/fulfillmentCompanyById/:id"
            element={<Navigate to="/shipping-rates" replace />}
          />
          <Route
            path="/fulfillment-shipping-cost/:id"
            element={<Navigate to="/shipping-rates" replace />}
          />
          <Route path="/stores" element={<StoresPage />} />
          <Route path="/sauces" element={<SaucesPage />} />
          <Route path="/sauce/:sauce_id" element={<SauceIdPage />} />
          <Route path="/accompaniments" element={<AccompanimentsPage />} />
          <Route path="/accompaniment/:accompaniment_id" element={<AccompanimentByIdPage />} />
          <Route
            path="/combo-2-x-1-products/:rule_id"
            element={<Product2x1Page />}
          />
          <Route
            path="/rules-2-x-1-products"
            element={<LegacyPromotionsRedirectPage promoType="2x1" />}
          />
          <Route
            path="/rules-3-x-2-products"
            element={<LegacyPromotionsRedirectPage promoType="3x2" />}
          />
          <Route
            path="/combo-3-x-2-products/:rule_id"
            element={<Product3x2Page />}
          />
          <Route path="/rules-fifty-off" element={<RulesFiftyOffPage />} />
          <Route path="/rules-sushi-lunch" element={<RulesSushiLunchPage />} />
          <Route
            path="/sushi-lunch-products/:rule_id"
            element={<SushiLunchProductsPage />}
          />
          <Route path="/support-tickets" element={<MessagesPage />} />
          <Route path="/promotions" element={<PromotionsPage />} />
          <Route path="/shipping-rates" element={<ShippingRatesPage />} />

          <Route path="/*" element={<Navigate to="/orders" replace />} />
        </>
      )}
      {!auth && (
        <>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={<Navigate to="/login" replace />} />
        </>
      )}
    </Routes>
  );
};
